import { c as _c } from "react/compiler-runtime";
import type { AccommodationRate } from '@data-access/graphql/schema.types';
import type { AvailableRoom } from '@feat/feat-accommodation/availability';
import { useMemo } from 'react';
import { create } from 'zustand';
import type { ActiveRoomState, PaxAllocation, RoomConfig, RoomConfigWithAllocation } from './room-picker-types';
type RoomPickerState = {
  roomConfigs: Map<string, RoomConfig>;
  activeRoom: ActiveRoomState;
  isRoomPaxModalOpen: boolean;
  allocation: PaxAllocation[] | null;
  selectedRate: AccommodationRate | null;
  selectedRoom: AvailableRoom | null;
};
export const INITIAL_ACTIVE_ROOM: ActiveRoomState = {
  allocationId: null,
  slideDirection: 0
};
export const useRoomPickerStore = create<RoomPickerState>()(() => ({
  roomConfigs: new Map<string, RoomConfig>(),
  activeRoom: INITIAL_ACTIVE_ROOM,
  isRoomPaxModalOpen: false,
  allocation: null,
  selectedRate: null,
  selectedRoom: null
}));
export function useRoomPickerRooms() {
  const $ = _c(3);
  const roomConfigs = useRoomPickerStore(_temp);
  const allocations = useRoomPickerStore(_temp2);
  let t0;
  let result;
  if ($[0] !== allocations || $[1] !== roomConfigs) {
    result = [];
    for (const [allocationId, roomConfig] of roomConfigs.entries()) {
      const allocation = allocations?.find(a => a.id === allocationId);
      if (!allocation) {
        continue;
      }
      result.push({
        ...roomConfig,
        allocation,
        allocationId
      });
    }
    $[0] = allocations;
    $[1] = roomConfigs;
    $[2] = result;
  } else {
    result = $[2];
  }
  t0 = result;
  return t0;
}
function _temp2(s_0) {
  return s_0.allocation;
}
function _temp(s) {
  return s.roomConfigs;
}
export function useActiveRoom() {
  const $ = _c(10);
  const activeRoomState = useRoomPickerStore(_temp3);
  const rooms = useRoomPickerRooms();
  const allocationId = activeRoomState.allocationId;
  let t0;
  if ($[0] !== allocationId || $[1] !== rooms) {
    t0 = allocationId ? rooms.findIndex(room => room.allocationId === allocationId) : null;
    $[0] = allocationId;
    $[1] = rooms;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const index = t0;
  let t1;
  if ($[3] !== allocationId || $[4] !== rooms) {
    t1 = allocationId ? rooms.find(room_0 => room_0.allocationId === allocationId) : null;
    $[3] = allocationId;
    $[4] = rooms;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const config = t1;
  let t2;
  if ($[6] !== activeRoomState || $[7] !== config || $[8] !== index) {
    t2 = {
      index,
      config,
      ...activeRoomState
    };
    $[6] = activeRoomState;
    $[7] = config;
    $[8] = index;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
}
function _temp3(s) {
  return s.activeRoom;
}
export function useSelectedRoomRate() {
  const $ = _c(3);
  const rate = useRoomPickerStore(_temp4);
  const room = useRoomPickerStore(_temp5);
  let t0;
  if ($[0] !== rate || $[1] !== room) {
    t0 = {
      rate,
      room
    };
    $[0] = rate;
    $[1] = room;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
}
function _temp5(t0) {
  const {
    selectedRoom
  } = t0;
  return selectedRoom;
}
function _temp4(t0) {
  const {
    selectedRate
  } = t0;
  return selectedRate;
}
export function useIsMultiRoom() {
  const allocation = useRoomPickerStore(_temp6);
  return (allocation?.length ?? 0) > 1;
}
function _temp6(s) {
  return s.allocation;
}